import _ from 'lodash'

/**
 *
 * @param {string} displayId - The ID of the deleted display
 * @param {Object[]} entities - The Entities to iterate
 * @param {function} callback - Callback function for each entity with the specified printer
 */
export default function (displayId, entities, callback) {
  if (_.isEmpty(entities)) {
    return
  }

  for (let entity of entities) {
    if (_.get(entity, 'kps.displays', []).includes(displayId)) {
      callback(entity)
    }
  }
}
